import { Component } from '@angular/core';

import { Message } from '../../models';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './alert-change-container-modal.component.html',
})
export class AlertChangeContainerModal {
  data: Message;
  success: Function;

  constructor() {}

  async onOkClicked(): Promise<void> {
    this.success();
  }

}
